import { MuPowerSolverLayerIds } from "fond/types";

import { ValidationFunction } from "./GenericValidator";

/**
 * A 3-phase path is valid if the first vertex is on a source hub and the last vertex is on a transformer hub.
 */
export const validateThreePhasePath: ValidationFunction = (feature, _allFeatures, helpers) => {
  const featureId = feature.id as string;

  if (feature.geometry.type !== "LineString") {
    return { featureId, valid: false, errors: ["3-phase path must be a LineString"] };
  }

  const coords = feature.geometry.coordinates;
  if (coords.length < 2) {
    return { featureId, valid: false, errors: ["3-phase path must have at least 2 vertices"] };
  }

  const firstVertex = coords[0];
  const lastVertex = coords[coords.length - 1];

  const startsAtSourceHub = helpers.findFeaturesAtPosition(firstVertex, MuPowerSolverLayerIds.sourceHubs).length > 0;
  const endsAtTransformer = helpers.findFeaturesAtPosition(lastVertex, MuPowerSolverLayerIds.transformerHubs).length > 0;

  const errors: string[] = [];
  if (!startsAtSourceHub) errors.push("3-phase path must start at a source hub");
  if (!endsAtTransformer) errors.push("3-phase path must end at a transformer");

  return { featureId, valid: errors.length === 0, errors };
};
